// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"54b4e590","276":"c9152bfc","515":"78fffff9","713":"d4f74700","954":"4d23ad8b","982":"54b4e590"}[chunkId] + ".chunk.css";
};